import { render, staticRenderFns } from "./ActivityPolicy.vue?vue&type=template&id=73da61d2&scoped=true&"
import script from "./ActivityPolicy.vue?vue&type=script&lang=js&"
export * from "./ActivityPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73da61d2",
  null
  
)

export default component.exports